import moment from "moment-timezone";
import { CustomHeader } from "tap/components/AGGrid/cell-renderers/CustomHeader.jsx";

export const id = {
  field: "id",
  headerName: "ID",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "id",
    page: "pmxPricesAndDates",
  },
  minWidth: 100,
};

export const isHistorical = {
  field: "isHistorical",
  headerName: "Historical Record from RL?",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "isHistorical",
    page: "pmxPricesAndDates",
  },
  valueFormatter: ({ value }) =>
    value == null ? "" : value === true ? "Yes" : "No",
  minWidth: 200,
};

export const catalogId = {
  field: "catalogId",
  headerName: "Catalog ID",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "catalogId",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const catalogName = {
  field: "catalogName",
  headerName: "Catalog",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "catalogName",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const catalogTemplate = {
  field: "catalogTemplate",
  headerName: "Catalog Template",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "catalogTemplate",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const pmxReleaseId = {
  field: "pmxReleaseId",
  headerName: "PMX Release ID",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "pmxReleaseId",
    page: "pmxPricesAndDates",
  },
  minWidth: 180,
};

export const territoryName = {
  field: "territoryName",
  headerName: "Territory",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "territoryName",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const productType = {
  field: "productType",
  headerName: "Product Type",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "productType",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const productConfig = {
  field: "productConfig",
  headerName: "Product Config",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "productConfig",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const productPlatform = {
  field: "productPlatform",
  headerName: "Product Platform",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "productPlatform",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const superPremiumEHVLStartDate = {
  field: "superPremiumEHVLStartDate",
  headerName: "Super Premium EHVL Start Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "superPremiumEHVLStartDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const superPremiumEHVLStartDateStatus = {
  field: "superPremiumEHVLStartDateStatus",
  headerName: "Super Premium EHVL Start Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "superPremiumEHVLStartDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const superPremiumEHVLTier = {
  field: "superPremiumEHVLTier",
  headerName: "Super Premium EHVL Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "superPremiumEHVLTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const superPremiumEHVLPrice = {
  field: "superPremiumEHVLPrice",
  headerName: "Super Premium EHVL Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "superPremiumEHVLPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const premiumEHVLStartDate = {
  field: "newReleasePEHVStartDate",
  headerName: "Premium EHVL Start Date",
  headerComponent: CustomHeader,
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponentParams: {
    colId: "newReleasePEHVStartDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const premiumEHVLStartDateStatus = {
  field: "newReleasePEHVStartDateStatus",
  headerName: "Premium EHVL Start Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "newReleasePEHVStartDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const premiumEHVLTier = {
  field: "premiumEHVLTier",
  headerName: "Premium EHVL Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "premiumEHVLTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const premiumEHVLPrice = {
  field: "premiumEHVLPrice",
  headerName: "Premium EHVL Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "premiumEHVLPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const newReleaseEHVLStartDate = {
  field: "newReleaseEHVLStartDate",
  headerName: "New Release EHVL Start Date",
  headerComponent: CustomHeader,
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponentParams: {
    colId: "newReleaseEHVLStartDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const currencyCodeEHVLPrice = {
  field: "currencyCodeFlexiPrice",
  headerName: "Currency Code EHVL Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "currencyCodeFlexiPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const newReleaseEHVLTier = {
  field: "newReleaseEHVLTier",
  headerName: "New Release EHVL Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "newReleaseEHVLTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const newReleaseEHVLPrice = {
  field: "newReleaseEHVLPrice",
  headerName: "New Release EHVL Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "newReleaseEHVLPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const newReleaseEHVLEpisodeTier = {
  field: "newReleaseEHVLEpisodeTier",
  headerName: "New Release EHVL Episode Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "newReleaseEHVLEpisodeTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const newReleaseEHVLEpisodePrice = {
  field: "newReleaseEHVLEpisodePrice",
  headerName: "New Release EHVL Episode Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "newReleaseEHVLEpisodePrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const newToCatalogEHVLStartDate = {
  field: "newtoCatalogEHVLStartDate",
  headerName: "New to Catalog EHVL Start Date",
  headerComponent: CustomHeader,
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponentParams: {
    colId: "newtoCatalogEHVLStartDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const newToCatalogEHVLStartDateStatus = {
  field: "newtoCatalogEHVLStartDateStatus",
  headerName: "New to Catalog EHVL Start Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "newtoCatalogEHVLStartDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const newToCatalogEHVLTier = {
  field: "newtoCatalogEHVLTier",
  headerName: "New to Catalog EHVL Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "newtoCatalogEHVLTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const newToCatalogEHVLPrice = {
  field: "newtoCatalogEHVLPrice",
  headerName: "New to Catalog EHVL Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "newtoCatalogEHVLPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const catalogEHVLStartDate = {
  field: "catalogEHVLStartDate",
  headerName: "Catalog EHVL Start Date",
  headerComponent: CustomHeader,
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponentParams: {
    colId: "catalogEHVLStartDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const catalogEHVLStartDateStatus = {
  field: "catalogEHVLStartDateStatus",
  headerName: "Catalog EHVL Start Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "catalogEHVLStartDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const catalogEHVLTier = {
  field: "catalogEHVLTier",
  headerName: "Catalog EHVL Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "catalogEHVLTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const catalogEHVLPrice = {
  field: "catalogEHVLPrice",
  headerName: "Catalog EHVL Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "catalogEHVLPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const catalogEHVLEpisodeTier = {
  field: "catalogEHVLEpisodeTier",
  headerName: "Catalog EHVL Episode Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "catalogEHVLEpisodeTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const catalogEHVLEpisodePrice = {
  field: "catalogEHVLEpisodePrice",
  headerName: "Catalog EHVL Episode Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "catalogEHVLEpisodePrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const presellEHVLStartDate = {
  field: "presellStartEHVDate",
  headerName: "Pre-Sell EHVL Start Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "presellStartEHVDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const presellStartEHVDateStatus = {
  field: "presellStartEHVDateStatus",
  headerName: "Pre-Sell EHVL Start Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "presellStartEHVDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const ehvlSupressionLiftDate = {
  field: "suppressionLiftEHVDate",
  headerName: "EHVL Suppression Lift Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "suppressionLiftEHVDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const ehvlSuppressionLiftDateStatus = {
  field: "suppressionLiftEHVStatus",
  headerName: "EHVL Suppression Lift Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "suppressionLiftEHVStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const ehvlSetPrice = {
  field: "setPrice",
  headerName: "EHVL Set Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "setPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const currencyCodeEHVLSetPrice = {
  field: "currencyCodeSetPrice",
  headerName: "Currency Code EHVL Set Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "currencyCodeSetPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const tvodSuperPremiumStartDate = {
  field: "tvodSuperPremiumStartDate",
  headerName: "TVOD Super Premium Start Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodSuperPremiumStartDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const tvodSuperPremiumStartDateStatus = {
  field: "tvodSuperPremiumStartDateStatus",
  headerName: "TVOD Super Premium Start Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodSuperPremiumStartDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const tvodSuperPremiumTier = {
  field: "tvodSuperPremiumTier",
  headerName: "TVOD Super Premium Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodSuperPremiumTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodSuperPremiumLicenseFee = {
  field: "tvodSuperPremiumLicenseFee",
  headerName: "TVOD Super Premium License Fee",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodSuperPremiumLicenseFee",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const tvodSuperPremiumMinDeemedPrice = {
  field: "tvodSuperPremiumMinDeemedPrice",
  headerName: "TVOD Super Premium Min Deemed Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodSuperPremiumMinDeemedPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const tvodPremiumStartDate = {
  field: "pvodNewReleaseStartDate",
  headerName: "TVOD Premium Start Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "pvodNewReleaseStartDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodPremiumStartDateStatus = {
  field: "pvodNewReleaseStartDateStatus",
  headerName: "TVOD Premium Start Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "pvodNewReleaseStartDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const tvodPremiumTier = {
  field: "tvodPremiumTier",
  headerName: "TVOD Premium Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodPremiumTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodPremiumLicenseFee = {
  field: "tvodPremiumLicenseFee",
  headerName: "TVOD Premium License Fee",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodPremiumLicenseFee",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodPremiumMinDeemedPrice = {
  field: "tvodPremiumMinDeemedPrice",
  headerName: "TVOD Premium Min Deemed Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodPremiumMinDeemedPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const tvodCurrentStartDate = {
  field: "tvodCurrentStartDate",
  headerName: "TVOD Current Start Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodCurrentStartDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodCurrentStartDateStatus = {
  field: "tvodCurrentStartDateStatus",
  headerName: "TVOD Current Start Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodCurrentStartDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const currencyCodeTVODLicenseFee = {
  field: "currencyCodeLicenseFee",
  headerName: "Currency Code TVOD License Fee",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "currencyCodeLicenseFee",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const currencyCodeTVODMinDeemedPrice = {
  field: "currencyCodeMinDeemedPrice",
  headerName: "Currency Code TVOD Min Deemed Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "currencyCodeMinDeemedPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const tvodCurrentTier = {
  field: "tvodCurrentTier",
  headerName: "TVOD Current Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodCurrentTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodCurrentLicenseFee = {
  field: "tvodCurrentLicenseFee",
  headerName: "TVOD Current License Fee",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodCurrentLicenseFee",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodCurrentMinDeemedPrice = {
  field: "tvodCurrentMinDeemedPrice",
  headerName: "TVOD Current Min Deemed Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodCurrentMinDeemedPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const tvodCurrentEpisodeTier = {
  field: "tvodCurrentEpisodeTier",
  headerName: "TVOD Current Episode Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodCurrentEpisodeTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodCurrentEpisodePrice = {
  field: "tvodCurrentEpisodePrice",
  headerName: "TVOD Current Episode Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodCurrentEpisodePrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodLibraryStartDate = {
  field: "tvodLibraryStartDate",
  headerName: "TVOD Library Start Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodLibraryStartDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodLibraryStartDateStatus = {
  field: "tvodLibraryStartDateStatus",
  headerName: "TVOD Library Start Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodLibraryStartDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const tvodLibraryTier = {
  field: "tvodLibraryTier",
  headerName: "TVOD Library Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodLibraryTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodLibraryLicensedFee = {
  field: "tvodLibraryLicensedFee",
  headerName: "TVOD Library License Fee",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodLibraryLicensedFee",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodLibraryMinDeemedPrice = {
  field: "tvodLibraryMinDeemedPrice",
  headerName: "TVOD Library Min Deemed Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodLibraryMinDeemedPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const tvodLibraryEpisodeTier = {
  field: "tvodLibraryEpisodeTier",
  headerName: "TVOD Library Episode Tier",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodLibraryEpisodeTier",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodLibraryEpisodePrice = {
  field: "tvodLibraryEpisodePrice",
  headerName: "TVOD Library Episode Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "tvodLibraryEpisodePrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodSupressionLiftDate = {
  field: "suppressionLiftVODDate",
  headerName: "TVOD Suppression Lift Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "suppressionLiftVODDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const tvodSupressionLiftDateStatus = {
  field: "suppressionLiftVODDateStatus",
  headerName: "TVOD Suppression Lift Date Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "suppressionLiftVODDateStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const consumerAnnouncementDate = {
  field: "ocad",
  headerName: "Consumer Announcement Date (OCAD)",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "ocad",
    page: "pmxPricesAndDates",
  },
  minWidth: 300,
};

export const physicalDate = {
  field: "physicalDate",
  headerName: "Physical Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "physicalDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const physicalStatus = {
  field: "physicalStatus",
  headerName: "Physical Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "physicalStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const physicalRetailPrice = {
  field: "physicalRetailPrice",
  headerName: "Physical Retail Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "physicalRetailPrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const currencyCodeWholesalePrice = {
  field: "currencyCodeWholesalePrice",
  headerName: "Currency Code Wholesale Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "currencyCodeWholesalePrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const physicalWholesalePrice = {
  field: "physicalWholesalePrice",
  headerName: "Physical Wholesale Price",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "physicalWholesalePrice",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const presellStartPhysicalDate = {
  field: "presellStartPhysicalDate",
  headerName: "Pre-Sell Start Physical Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("YYYY-MM-DD") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "presellStartPhysicalDate",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const presellStartPhysicalStatus = {
  field: "presellStartPhysicalStatus",
  headerName: "Pre-Sell Start Physical Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "presellStartPhysicalStatus",
    page: "pmxPricesAndDates",
  },
  minWidth: 250,
};

export const created = {
  field: "createdAt",
  headerName: "Created",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("DD-MMM-YYYY")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdAt",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};

export const modified = {
  field: "modifiedAt",
  headerName: "Modified",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("DD-MMM-YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "modifiedAt",
    page: "pmxPricesAndDates",
  },
  minWidth: 200,
};
